import { AlertTriangle } from 'lucide-react';

import { cn } from '@/lib/cn';

interface Action {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
}

interface Props {
  title: string;
  detail?: string;
  actions: ReadonlyArray<Action>;
  className?: string;
}

export function StepError({ title, detail, actions, className }: Props) {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col gap-3 rounded-xl border border-red-500/40 bg-red-500/10 p-4 text-sm text-fg',
        className,
      )}
    >
      <div className="flex items-start gap-2">
        <AlertTriangle aria-hidden className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
        <div className="flex flex-col gap-1">
          <p className="font-semibold">{title}</p>
          {detail && <p className="text-xs text-fg-muted">{detail}</p>}
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {actions.map(action => (
          <button
            key={action.label}
            type="button"
            onClick={action.onClick}
            className={cn(
              'rounded-lg px-3 py-1.5 text-xs font-semibold transition-opacity active:opacity-80',
              action.variant === 'primary'
                ? 'bg-brand text-brand-fg'
                : 'bg-bg-secondary text-fg',
            )}
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
}
